/* ROVINA landing page — behaviour */
(function () {
  if (window.__rvInit) return;
  window.__rvInit = true;
  var docEl = document.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (!designMode && 'IntersectionObserver' in window) docEl.classList.add('rv-js');

  function initMain(root) {
    if (root.__rv) return;
    root.__rv = true;
    var form = root.querySelector('form.rv-form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var btn = root.querySelector('[data-rv-atc]');
    var btnLabel = root.querySelector('[data-rv-atc-label]');
    var priceEls = root.querySelectorAll('[data-rv-price]');
    var stickyPrice = root.querySelector('[data-rv-sticky-price]');
    var stickyBtn = root.querySelector('[data-rv-sticky-btn]');
    var buyNow = root.querySelector('[data-rv-buynow]');
    var addText = btnLabel ? btnLabel.getAttribute('data-add') : 'Add to cart';
    var soldText = btnLabel ? btnLabel.getAttribute('data-sold') : 'Sold out';

    function apply(card) {
      if (!card) return;
      root.querySelectorAll('.rv-offer').forEach(function (c) { c.classList.toggle('is-checked', c === card); });
      var ok = card.getAttribute('data-available') === 'true';
      idInput.value = card.getAttribute('data-variant');
      qtyInput.value = card.getAttribute('data-qty') || 1;
      priceEls.forEach(function (el) { el.textContent = card.getAttribute('data-total'); });
      if (stickyPrice) stickyPrice.textContent = card.getAttribute('data-label') + ' · ' + card.getAttribute('data-total');
      [btn, stickyBtn, buyNow].forEach(function (b) { if (b) b.disabled = !ok; });
      if (btnLabel) btnLabel.textContent = ok ? addText : soldText;
    }
    root.querySelectorAll('.rv-offer input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () { apply(input.closest('.rv-offer')); });
    });
    var checked = root.querySelector('.rv-offer input:checked');
    if (checked) apply(checked.closest('.rv-offer'));

    // gallery
    var track = root.querySelector('.rv-gal__track');
    if (track) {
      var slides = track.querySelectorAll('.rv-gal__slide');
      var thumbs = root.querySelectorAll('.rv-gal__thumb');
      var dots = root.querySelectorAll('.rv-gal__dot');
      function setActive(i) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          setActive(i);
        });
      });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
        });
      }, { passive: true });
    }

    // sticky add-to-cart
    var sticky = root.querySelector('.rv-sticky');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(btn);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rv-main]').forEach(initMain);
    if (!docEl.classList.contains('rv-js')) return;
    var io = initAll.io || (initAll.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' }));
    (scope || document).querySelectorAll('.rv-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
  }

  // smooth scroll to the buy box
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#rv-buy"]');
    if (!a) return;
    var target = document.getElementById('rv-buy');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
